import { cx } from "class-variance-authority";
import { MenuTrigger as AriaMenuTrigger } from "react-aria-components";
import useMeasure from "react-use-measure";

import type { MenuProps } from "@/components/ui/Menu/Menu";
import { MenuPopover } from "@/components/ui/Menu/MenuPopover";

export const MenuDesktop = ({
  trigger,
  items,
  triggerClassName,
  popoverProps,
  id,
  isOpen,
  onOpenChange,
}: MenuProps) => {
  const [triggerRef, { width }] = useMeasure();
  return (
    <AriaMenuTrigger
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      <div
        ref={triggerRef}
        className={cx("w-auto flex-auto", triggerClassName)}
        id={id}
      >
        {trigger}
      </div>

      <MenuPopover
        {...popoverProps}
        offset={0}
        className={cx("pt-2", popoverProps?.className)}
        items={items}
        style={{ width: width || undefined }}
      />
    </AriaMenuTrigger>
  );
};
